import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { devisionCards } from 'sections/Benefits/Support/data';
import useWindowSize from 'utils/hooks/useWindowSize';
import Card from 'components/Card';
import styles from 'sections/Benefits/Support/components/SectionDevisionCards/SectionDevisionCards.module.scss';

const cn = classNames.bind(styles);

const SectionDevisionCards = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const devisionCardsList = devisionCards.map((card) => {
    return (
      <Card className={cn('devision-card')} key={card.icon}>
        <div className={cn('devision-card__content')}>
          <Card.Header className={cn('devision-card__title-box')}>
            <div className={cn('devision-card__icon')}>
              <img src={`/images/pages/Benefits/Support/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('devision-card__title')}>{card.title}</h3>
          </Card.Header>  
          <Card.Content className={cn('devision-card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('devision-cards')}>
      <div className={cn('container')}>
        <div className={cn('devision-cards__title-box')}>
          {screenWidth >= 576
            ?
            <h2 className={cn('devision-cards__title')}>
              <span>Maximise Your Business Potential</span> 
              <span>with DFA Networking</span>
            </h2>
            :
            <h2 className={cn('devision-cards__title')}>
              Maximise Your Business Potential with DFA Networking
            </h2>
          }
          {screenWidth >= 576
            ?
            <p className={cn('devision-cards__title-description')}>
              <span>Discover how our networking benefits can elevate your</span> 
              <span>freight forwarding operations.</span>
            </p>
            :
            <p className={cn('devision-cards__title-description')}>
              Discover how our networking benefits can elevate your freight forwarding operations. 
            </p>
          }
        </div>
          <ul className={cn('devision-cards__list')}>
            {devisionCardsList}
        </ul>
      </div>
    </section>
  );
};

export default SectionDevisionCards;